import { NgModule }       from '@angular/core';
import { BrowserModule  } from '@angular/platform-browser';
import { HttpModule }     from '@angular/http';
import { JsonpModule }     from '@angular/http';

import { SharedModule } from './shared.module';
import { AppComponent }   from './app.component';

/**This portion below only works when working with Webpack. For SystemJS, comment out the following lines**/
import 'material-design-lite/dist/material.blue_grey-indigo.min.css';
import 'mdl-selectfield/dist/mdl-selectfield.min.css';
import './styles.css';

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        BrowserModule,
        HttpModule,
        JsonpModule,
        //RouterModule,
        SharedModule.forRoot()
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
    constructor(){
        
    }
}


// WEBPACK FOOTER //
// ./app/app.module.ts